export default "__VITE_ASSET__f0d27e72__"